import React from "react"
import {
  Wrapper,
  NBLInfoContent,
  NBLMiddleInfoContent,
} from "./../../PrintListContent.style"
import { ReceiptUpperLimitManagement } from "../../../../types"
import { PRINT_CONFIGURATION_OPTION_VALUES } from "../../../../constants"
import { t } from "i18next"
import { KyotoSheetTitle } from "../header/sheetTitle/KyotoSheetTitle"
import { YearMonth } from "../../common/header/YearMonth"
import { DefaultChildDetail } from "../header/childDetail/DefaultChildDetail"
import { ManagementFacility } from "../../common/header/ManagementFacility"
import { KyotoUpperMonthLimit } from "../../common/header/upperMonthLimit/KyotoUpperMonthLimit"
import { DefaultUpperLimitManagementResult } from "../../common/header/upperLimitManagementResult/DefaultUpperLimitManagementResult"
import { KyotoFormat } from "../body/KyotoFormat"
import { DefaultSignature } from "../../common/footer/signature/DefaultSignature"

type Props = {
  receiptUpperLimitManagement: ReceiptUpperLimitManagement
  printConfig: string[]
}

export function KyotoFlame({
  receiptUpperLimitManagement,
  printConfig = [],
}: Props) {
  return (
    <Wrapper>
      {printConfig.includes(
        PRINT_CONFIGURATION_OPTION_VALUES.PRINT_FORM_NUMBER
      ) && <small>{t("(Form 2)")}</small>}

      {/* --- Start Header */}
      <KyotoSheetTitle />
      <YearMonth
        year={receiptUpperLimitManagement.year}
        month={receiptUpperLimitManagement.month}
      />
      <NBLInfoContent length={1}>
        <div className={"top__table_content"}>
          <DefaultChildDetail
            municipalityNumber={receiptUpperLimitManagement.municipality_number}
            receivingCertificateNumber={
              receiptUpperLimitManagement.receiving_certificate_number
            }
            childName={receiptUpperLimitManagement.child_name}
            parentName={receiptUpperLimitManagement.parent_name}
            printConfig={printConfig}
          />
        </div>
        <div className={"top__table_content"}>
          <ManagementFacility
            facilityName={receiptUpperLimitManagement.facility_name}
            facilityNumber={receiptUpperLimitManagement.facility_number}
          />
        </div>
      </NBLInfoContent>
      <NBLMiddleInfoContent>
        <div className={"NBLMiddleInfoContent"}>
          <div className={"nbl_info_top_content"}>
            <KyotoUpperMonthLimit
              burdenMaxMonth={receiptUpperLimitManagement.burden_max_month}
              localBurdenMaxMonth={
                receiptUpperLimitManagement.local_burden_max_month
              }
            />
          </div>
          <div className={"nbl_info_bottom_content"}>
            <DefaultUpperLimitManagementResult
              managementResult={receiptUpperLimitManagement.management_result}
            />
          </div>
        </div>
      </NBLMiddleInfoContent>
      {/* --- End Header */}

      {/* --- Start Body */}
      <KyotoFormat
        facilities={receiptUpperLimitManagement.facilities}
        totalAmount={receiptUpperLimitManagement.total_amount}
        totalBurdenAmount={receiptUpperLimitManagement.total_burden_amount}
        managementResultBurdenAmount={
          receiptUpperLimitManagement.management_result_burden_amount
        }
      />
      {/* --- End Body */}

      {/* --- Start Footer */}
      <DefaultSignature printConfig={printConfig} />
      {/* --- End Footer */}
    </Wrapper>
  )
}
